import gql from 'graphql-tag';

const edges = `
  edges {
    node {
      name
      id
    }
  }
`;

export const TOPIC_FRAGMENT = gql`
  fragment topic on TopicType {
    id
    slug

    name
    createdAt
    headerImage
    headerSubtitle
    headerDescription

    tagsTitle
    tagsLanguages {
     ${edges} 
    }
    tagsActivities {
      ${edges} 
    }
    tagsTopics {
      ${edges} 
    }
    tagsArts {
      ${edges} 
    }
    tagsExpenditures { 
      ${edges} 
    }
    
    campaignTitle
    campaignImage
    campaignButtonUrl
    campaignButtonText
    campaignDescription
    
    seoAreaDescription

    projectsCount
    thumbnailImage
  }
`;
